import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/Home";
import index from "@/views/index/index";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: "/hcxh/", //当项目不在根目录时，必须添加子目录路径，否则空白页面
  routes: [
    {
      path: "/test",
      component: () => import("@/views/test")
    },
    {
      path: "/index",
      name: "index",
      component: Home,
      children: [
        {
          path: "/index",
          name: "index",
          component: index
        }
      ]
    },
    {
      path: "/xny",
      name: "xny",
      component: Home,
      children: [
        {
          path: "wdw",
          component: () => import("@/views/xny/wdw")
        },
        {
          path: "gfdz",
          component: () => import("@/views/xny/gfdz")
        },
        {
          path: "zhny",
          component: () => import("@/views/xny/zhny")
        },
        {
          path: "fgcc",
          component: () => import("@/views/xny/fgcc"),
          meta: {
            keepAlive: true // 需要缓存
          }
        },
        {
          path: "fgcc-detail",
          component: () => import("@/views/xny/fgcc-detail")
        }
      ]
    },
    {
      path: "/robot",
      name: "robot",
      component: Home,
      children: [
        {
          path: "robot-1",
          component: () => import("@/views/robot/robot-1")
        },
        {
          path: "robot-2",
          component: () => import("@/views/robot/robot-2")
        },
        {
          path: "robot-3",
          component: () => import("@/views/robot/robot-3")
        },
        {
          path: "robot-4",
          component: () => import("@/views/robot/robot-4")
        },
        {
          path: "robot-5",
          component: () => import("@/views/robot/robot-5")
        },
        {
          path: "robot-6",
          component: () => import("@/views/robot/robot-6")
        },
        {
          path: "robot-1-detail",
          component: () => import("@/views/robot/robot-1-detail")
        },
        {
          path: "robot-3-detail",
          component: () => import("@/views/robot/robot-3-detail")
        },
        {
          path: "robot-4-detail",
          component: () => import("@/views/robot/robot-4-detail")
        },
        {
          path: "robot-5-detail",
          component: () => import("@/views/robot/robot-5-detail")
        }
      ]
    },
    {
      path: "/zhjc",
      name: "zhjc",
      component: Home,
      children: [
        {
          path: "pdzf",
          component: () => import("@/views/zhjc/pdzf")
        },
        {
          path: "gydl",
          component: () => import("@/views/zhjc/gydl")
        },
        {
          path: "sdxl",
          component: () => import("@/views/zhjc/sdxl")
        }
      ]
    },
    {
      path: "/znyc",
      name: "znyc",
      component: Home,
      children: [
        {
          path: "wfx",
          component: () => import("@/views/znyc/wfx")
        },
        {
          path: "sjxt",
          component: () => import("@/views/znyc/sjxt")
        }
      ]
    },
    {
      path: "/rjpt",
      name: "rjpt",
      component: Home,
      children: [
        {
          path: "dljk",
          component: () => import("@/views/rjpt/dljk")
        },
        {
          path: "pdzf",
          component: () => import("@/views/rjpt/pdzf")
        },
        {
          path: "gydl",
          component: () => import("@/views/rjpt/gydl")
        },
        {
          path: "dlgl",
          component: () => import("@/views/rjpt/dlgl")
        },
        {
          path: "dlyw",
          component: () => import("@/views/rjpt/dlyw")
        },
        {
          path: "tqcn",
          component: () => import("@/views/rjpt/tqcn")
        }
      ]
    },
    {
      path: "/about",
      name: "about",
      component: Home,
      children: [
        {
          path: "me",
          component: () => import("@/views/about/me")
        },
        {
          path: "news",
          component: () => import("@/views/about/news.vue")
        },
        {
          path: "news-detail",
          component: () => import("@/views/about/news-detail")
        }
      ]
    },
    {
      path: "/",
      redirect: "/index"
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    console.log(savedPosition, to.path, "11111111");
    if (savedPosition) {
      return savedPosition;
    }
    if (
      to.path == "/robot/robot-1-detail" ||
      to.path == "/robot/robot-3-detail" ||
      to.path == "/robot/robot-4-detail" ||
      to.path == "/robot/robot-5-detail" ||
      to.path == "/xny/fgcc-detail"
    ) {
      return {
        y: document.documentElement.clientHeight
      };
    }
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js